import { render, staticRenderFns } from "./ComprehensiveCustomized.vue?vue&type=template&id=8ad3aac0&scoped=true&"
import script from "./ComprehensiveCustomized.vue?vue&type=script&lang=js&"
export * from "./ComprehensiveCustomized.vue?vue&type=script&lang=js&"
import style0 from "./ComprehensiveCustomized.vue?vue&type=style&index=0&id=8ad3aac0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad3aac0",
  null
  
)

export default component.exports